// App.js
import React from "react";
import { useState, useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import ManagementSidebar from "./scenes/global/ManagementSidebar";
import Dashboard from "./scenes/dashboard";
import Team from "./scenes/team";
import Invoices from "./scenes/invoices";
import Contacts from "./scenes/contacts";
import Bar from "./scenes/bar";
import Form from "./scenes/form";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import FAQ from "./scenes/faq";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import AnrPage from "./scenes/Anr/AnrPage";
import AddProject from "./scenes/Anr/AddAnr";
import MyCalendar from "./scenes/calendar/MyCalendar";
import AnrMachine from "./scenes/Anr/AnrMachine";
import MonthlyReport from "./scenes/team/report";
import AnrPlans from "./scenes/Anr/AnrPlans";
import ProjectReports from "./scenes/Reports/ProjectReports";
import ProjectSummary from "./scenes/Reports/ProjectSummary";
import ProjectHours from "./scenes/Reports/ProjectHours";
import BulkReport from "./scenes/Reports/bulkReport";
import BulkReportExcel from "./scenes/Reports/bulkReportExcel";
import ExcelProcessor from "./scenes/Reports/manualReportData";
import CalculatedReport from "./scenes/Reports/calculatedReport";
import Comparision from "./scenes/Reports/comparison";
import MainAggregation from "./scenes/Reports/mainAggregation";
import OcrTable from "./scenes/ocr/ocr";
import AIAssistantPage from "./scenes/AIAssistant";
import Attendance from "./scenes/team/Attendance";
import TaskLogger from "./scenes/Admins/TaskLogger";
import CheckInCheckOut from "./scenes/Admins/CheckInCheckOut";
import ManagementCheckInTable from "./scenes/Admins/CheckInView";
import TaskLogPage from "./scenes/Admins/TaskLogsView";
import AttendanceCalendar from "./scenes/team/AttendanceCalendar";
import AttendanceReport from "./scenes/team/AttenedanceReport";
import UberStundens from "./scenes/team/Uberstundens";
import TemplateMaker from "./scenes/ProjectPlanning/TemplateMaker";
import AttendanceMonthlyUsers from "./scenes/team/AttendanceMonthlyUser";
import ProjectDetails from "./scenes/Anr/ProjectDetails";
import AddFirma from "./scenes/Anr/AddFirms";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import MainPlanning from "./scenes/ProjectPlanning/MainPlanning";
import AddProcess from "./scenes/Processes/AddProcess";
import AddEmployee from "./scenes/team/AddEmployee";
import AddSkills from "./scenes/team/AddSkills";
import EmployeeSkillsMatrix from "./scenes/team/EmployeeSkillsMatrix";
import EmployeeView from "./scenes/team/ListEmployee";
import FirmaTable from "./scenes/Anr/ListFirma";
import UploadBulkRechnung from "./scenes/invoices/uploadBulkRechnung";
import Rechnungs from "./scenes/invoices/Rechnungs";
import MachineSkillsMatrix from "./scenes/ProjectPlanning/MachineSkillMatrix";
import GanttChart from "./scenes/ProjectPlanning/Gantt";
import ProjectScheduler from "./scenes/ProjectPlanning/ProjectScheduler";
import EmployeeUpdate from "./scenes/team/updateEmployee";
import AddShift from "./scenes/team/AddShifts";
import ShiftTable from "./scenes/team/ViewShifts";
import EmployeeShiftCalendar from "./scenes/ProjectPlanning/EmployeeShiftCalendar";
import UrlaubPlanner from "./scenes/ProjectPlanning/UrlaubPlanner";
import PlanningTable from "./scenes/ProjectPlanning/PlanningTable";
import AddRechnungs from "./scenes/Admins/Rechnungs/Addrechnungs";
import Finalcalculations from "./scenes/Reports/finalcalculations";
import FinalCalculationsProcessor from "./scenes/Reports/finalprocessor";
import SumOfAll from "./scenes/Admins/sumOfAll";
import RechnungMatcher from "./scenes/Reports/RechnungMatcher";
import CombinedCalendarMain from "./scenes/ProjectPlanning/CombinedCalendarMain";
import { ArcherContainer, ArcherElement } from "react-archer";
import MainCalendar2 from "./scenes/ProjectPlanning/MainCalendar2";
import BottomTabNavigator from "./scenes/global/BottomTabNavigator";
import InteractivePlanningCalendar from "./scenes/ProjectPlanning/InteractivePlanner";
import InvoiceGenerator from "./scenes/invoices/InvoiceGenerator";
import InvoiceList from "./scenes/invoices/InvoiceTemplateList";
import "./App.css";
import Navbar from "./scenes/global/Navbar";
import ContactPersonForm from "./scenes/Firma";
import Bestallung from "./scenes/bestallung";
import BestellungDetails from "./scenes/bestallung/details";
import EmailInbox from "./scenes/bestallung/events";
import ViewBestallungs from "./scenes/bestallung/ViewBestallungs";
import LieferantTable from "./scenes/Anr/LieferantTable";
import AnfrageForm from "./Anfrage/createAnfrage";
import AnfrageList from "./Anfrage/ListAnfrage";
import KundenPage from "./scenes/Kunden";
import DocumentLabeler from "./filemanger";
import FileManager from "./filemanger/FileManager";
import AnfrageUploader from "./filemanger/AnfrageUploader";
import AnfrageFileManager from "./filemanger/AnfrageFileManager";
import UploadInvoicePageQR from "./scenes/invoices/UploadInvoicePageQR";
import MainAufgabeBoard from "./scenes/Aufgabe";
import EventsCalendar from "./scenes/EventsCalendar";
import UploadAnrDocumentQR from "./scenes/Anr/UploadAnrDocumentQR";
import IncomingInvoiceForm from "./scenes/invoices/incomingInvoices";
import ProfitLossDashboard from "./scenes/dashboard/ProfitLossDashboard";
import ProfitLossDashboard2 from "./scenes/dashboard/ProfitLossDashboard2";
import GoogleSheet from "./GoogleSheet";
import EmployeeMachineMatrix from "./scenes/Matrix/EmployeeMachineMatrix";
import Planner2 from "./scenes/ProjectPlanning/Planner2";
import TemplateProjectPlanner from "./scenes/ProjectPlanning/templateProjectPlanner";
import SignIn from "./scenes/Auth/SignIn";
import PrivateRoute from "./scenes/Auth/PrivateRoute";
import AnfrageInvoiceUpload from "./Anfrage/AnfrageInvoiceUpload";
import ProfitLossDashboard3 from "./scenes/ProfitLossDashboard/ProfitLossDashboard3";
import ProjectFinancialDetails from "./scenes/ProfitLossDashboard/ProjectFinancialDetails";
import KundenManagement from "./scenes/Kunden";
import KanbanANRPage from "./scenes/Aufgabe/AufgabeANR";
import UserTable from "./scenes/User/usersTable";
import UserProfile from "./scenes/User/userProfile";
import Lexware from "./lexware";
import ExcelBulkPage from "./Rechnungs";
import ReklamationSystem from "./scenes/Reklamation";
import InvoiceDashboard from "./invoices/InvoiceDashboard";
import ProfitLossInvoices from "./scenes/ProfitLossDashboard/ProfitLossInvoices";
import ReklamationDetailView from "./scenes/Reklamation/ReklamationDetailView";
import ReklamationOverview from "./scenes/Reklamation/ReklamationOverview";
import EmployeeHoursEvaluation from "./scenes/team/EmployeeHoursEvaluation";

// Stock Management Components
import StockManagement from "./scenes/StockManagement";
import StockDashboard from "./scenes/Stock/StockDashboard";

// Warehouse Management Components
import WarehouseList from "./scenes/Warehouse/WarehouseList";
import WarehouseDesigner from "./scenes/Warehouse/WarehouseDesigner";
import ProductsList from "./scenes/Stock/ProductsList";
import ProductForm from "./scenes/Stock/ProductForm";
import StockMovementsList from "./scenes/Stock/StockMovementsList";
import StockMovementForm from "./scenes/Stock/StockMovementForm";
import AnrStockList from "./scenes/Stock/AnrStockList";
import OdooConfig from "./scenes/Stock/OdooConfig";
import StockAuftrage from "./scenes/Stock/StockAuftrage";
import StockAuftrageView from "./scenes/Stock/StockAuftrageView";
import ProcessImprovementPage from "./scenes/ProcessImpovements";
import AdvancedManagementLog from "./scenes/Admins/AdvancedManagementLog";
import LoggedInUsers from "./scenes/Admins/LoggedInUsers";
// import CustomFormBuilder from "./components/CustomForm/CustomFormBuilder";
import FormManagement from "./scenes/FormManagement";
import Team2 from "./scenes/team/team2";
import ProjectProfitability from "./scenes/ProjectPlanning/ProjectProfitability";
import ProductView from "./scenes/Stock/ProductView";
import ProductLogs from "./scenes/Stock/StockLogs";
import StockAnr from "./scenes/Stock/StockAnr";
import SimpleAppAdmin from "./scenes/SimpleAppAdmin";

function App() {
  const [theme, colorMode] = useMode();
  const [sidebarType, setSidebarType] = useState("default");
  const location = useLocation();

  useEffect(() => {
    const managementPaths = [
      "/tasklogger",
      "/checkincheckout",
      "/managementcheckintable",
      "/task-logs",
      "/managementlogs",
      "/logged-in-users",
    ];

    const pathname = location.pathname.toLowerCase();
    const searchParams = new URLSearchParams(location.search);
    const hasTaskLogsQueryParam = searchParams.has("task-logs");

    if (managementPaths.includes(pathname) || hasTaskLogsQueryParam) {
      setSidebarType("management");
    } else {
      setSidebarType("default");
    }
  }, [location.pathname, location.search]);

  const hideNavbar = location.pathname === "/signin";

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              zIndex: 1100,
            }}
          >
            {!hideNavbar && <Navbar />}
          </div>
          <main
            className="content"
            style={{ marginTop: hideNavbar ? 0 : "60px" }}
          >
            <DndProvider backend={HTML5Backend}>
              <Routes>
                {/* public routes  */}
                <Route path="/signin" element={<SignIn />} />
                <Route
                  path="/anfrageInvoiceUpload/:anf"
                  element={<AnfrageInvoiceUpload />}
                />
                <Route
                  path="/UploadAnrDocumentQR"
                  element={<UploadAnrDocumentQR />}
                />
                {/* private routes  */}
                <Route element={<PrivateRoute />}>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/team" element={<Team />} />
                  <Route path="/contacts" element={<Contacts />} />
                  <Route path="/invoices" element={<Invoices />} />
                  <Route path="/form" element={<Form />} />
                  <Route path="/bar" element={<Bar />} />
                  <Route path="/pie" element={<Pie />} />
                  <Route path="/line" element={<Line />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/calendar" element={<Calendar />} />
                  <Route path="/geography" element={<Geography />} />
                  <Route path="/anrtable" element={<AnrPage />} />
                  <Route path="/addanr" element={<AddProject />} />
                  <Route path="/anrcalendar" element={<MyCalendar />} />
                  <Route path="/anrs/:number" element={<AnrMachine />} />
                  <Route path="/monthlyreport" element={<MonthlyReport />} />
                  <Route path="/anrplans" element={<AnrPlans />} />
                  <Route path="/projectreports" element={<ProjectReports />} />
                  <Route
                    path="/anrprofitability"
                    element={<ProjectProfitability />}
                  />

                  <Route
                    path="/projectsummary/:anr"
                    element={<ProjectSummary />}
                  />
                  <Route path="/bulkreport" element={<BulkReport />} />
                  <Route path="/projecthours" element={<ProjectHours />} />
                  <Route
                    path="/bulkreportexcel"
                    element={<BulkReportExcel />}
                  />
                  <Route path="/manualreporting" element={<ExcelProcessor />} />
                  <Route
                    path="/calculatedreport"
                    element={<CalculatedReport />}
                  />
                  <Route path="/comparision" element={<Comparision />} />
                  <Route
                    path="/mainaggregation"
                    element={<MainAggregation />}
                  />
                  <Route path="/ocr" element={<OcrTable />} />
                  <Route path="/attendance" element={<Attendance />} />
                  <Route path="/tasklogger" element={<TaskLogger />} />
                  <Route
                    path="/checkincheckout"
                    element={<CheckInCheckOut />}
                  />
                  <Route
                    path="/managementcheckintable"
                    element={<ManagementCheckInTable />}
                  />
                  <Route path="/task-logs" element={<TaskLogPage />} />
                  <Route
                    path="/managementLogs"
                    element={<AdvancedManagementLog />}
                  />
                  <Route path="/logged-in-users" element={<LoggedInUsers />} />
                  <Route
                    path="/AttendanceCalendar"
                    element={<AttendanceCalendar />}
                  />
                  <Route
                    path="/AttendanceReport"
                    element={<AttendanceReport />}
                  />
                  <Route path="/UberStundens" element={<UberStundens />} />
                  <Route
                    path="/employee-hours-evaluation"
                    element={<EmployeeHoursEvaluation />}
                  />
                  <Route path="/TemplateMaker" element={<TemplateMaker />} />
                  <Route
                    path="/template-planner"
                    element={<TemplateProjectPlanner />}
                  />
                  <Route
                    path="/AttendanceMonthlyUsers"
                    element={<AttendanceMonthlyUsers />}
                  />
                  <Route
                    path="/ProjectDetails/:anr"
                    element={<ProjectDetails />}
                  />
                  <Route path="/AddFirma" element={<AddFirma />} />
                  <Route
                    path="/TemplateList"
                    element={<CombinedCalendarMain />}
                  />
                  {/* <Route path="/ProjectCalendar" element={<ProjectCalendar />} /> */}
                  <Route path="/MainPlanning" element={<MainCalendar2 />} />
                  <Route path="/AddProcess" element={<AddProcess />} />
                  <Route path="/AddEmployee" element={<AddEmployee />} />
                  <Route path="/AddSkills" element={<AddSkills />} />
                  <Route
                    path="/EmployeeSkillsMatrix"
                    element={<EmployeeSkillsMatrix />}
                  />
                  <Route path="/EmployeeView" element={<EmployeeView />} />
                  <Route path="/FirmaTable" element={<FirmaTable />} />
                  <Route
                    path="/UploadBulkRechnung"
                    element={<UploadBulkRechnung />}
                  />
                  <Route path="/Rechnung" element={<Rechnungs />} />
                  <Route
                    path="/MachineSkillsMatrix"
                    element={<MachineSkillsMatrix />}
                  />
                  <Route path="/GanttChart" element={<GanttChart />} />
                  <Route
                    path="/ProjectScheduler"
                    element={<ProjectScheduler />}
                  />
                  <Route
                    path="/employee/update/:id"
                    element={<EmployeeUpdate />}
                  />
                  <Route path="/AddShift" element={<AddShift />} />
                  <Route path="/ShiftTable" element={<ShiftTable />} />
                  <Route
                    path="/EmployeeShiftCalendar"
                    element={<EmployeeShiftCalendar />}
                  />
                  <Route path="/UrlaubPlanner" element={<UrlaubPlanner />} />
                  <Route path="/PlanningTable" element={<PlanningTable />} />
                  <Route path="/AddRechnungs" element={<AddRechnungs />} />
                  <Route
                    path="/Finalcalculations"
                    element={<Finalcalculations />}
                  />
                  <Route
                    path="/FinalCalculationsProcessor"
                    element={<FinalCalculationsProcessor />}
                  />
                  <Route path="/sumOfAll" element={<SumOfAll />} />
                  <Route
                    path="/RechnungMatcher"
                    element={<RechnungMatcher />}
                  />
                  <Route
                    path="/CombinedCalendarMain"
                    element={<CombinedCalendarMain />}
                  />
                  <Route path="/MainCalendar2" element={<MainCalendar2 />} />
                  <Route
                    path="/InteractivePlanningCalendar"
                    element={<InteractivePlanningCalendar />}
                  />
                  <Route
                    path="/InvoiceGenerator"
                    element={<InvoiceGenerator />}
                  />
                  <Route path="/InvoiceList" element={<InvoiceList />} />
                  <Route path="/invoice/new" element={<InvoiceGenerator />} />
                  <Route
                    path="/invoice/edit/:templateId"
                    element={<InvoiceGenerator />}
                  />
                  <Route
                    path="/ContactPersonForm"
                    element={<ContactPersonForm />}
                  />
                  <Route path="/Bestallung" element={<Bestallung />} />
                  <Route
                    path="/BestellungDetails/:id"
                    element={<BestellungDetails />}
                  />
                  <Route path="/EmailInbox" element={<EmailInbox />} />
                  <Route
                    path="/ViewBestallungs"
                    element={<ViewBestallungs />}
                  />
                  <Route path="/LieferantTable" element={<LieferantTable />} />
                  <Route path="/AnfrageForm" element={<AnfrageForm />} />
                  <Route path="/AnfrageList" element={<AnfrageList />} />
                  <Route path="/KundenPage" element={<KundenPage />} />
                  <Route
                    path="/DocumentLabeler/:anr"
                    element={<DocumentLabeler />}
                  />
                  <Route path="/FileManager/:anr" element={<FileManager />} />
                  <Route
                    path="/AnfrageUploader/:anf"
                    element={<AnfrageUploader />}
                  />
                  <Route
                    path="/AnfrageFileManager/:anf"
                    element={<AnfrageFileManager />}
                  />
                  <Route
                    path="/UploadInvoicePageQR"
                    element={<UploadInvoicePageQR />}
                  />
                  <Route
                    path="/MainAufgabeBoard/*"
                    element={<MainAufgabeBoard />}
                  />
                  <Route path="/EventsCalendar" element={<EventsCalendar />} />
                  <Route
                    path="/IncomingInvoiceForm"
                    element={<IncomingInvoiceForm />}
                  />
                  <Route
                    path="/ProfitLossDashboard"
                    element={<ProfitLossInvoices />}
                  />
                  <Route
                    path="/ProfitLossDashboard2"
                    element={<ProfitLossDashboard2 />}
                  />
                  <Route path="/GoogleSheet" element={<GoogleSheet />} />
                  <Route
                    path="/EmployeeMachineMatrix"
                    element={<EmployeeMachineMatrix />}
                  />
                  <Route path="/Planner2" element={<Planner2 />} />
                  <Route
                    path="/ProjectFinancialDetails"
                    element={<ProjectFinancialDetails />}
                  />
                  <Route
                    path="/ProfitLossDashboard3"
                    element={<ProfitLossDashboard3 />}
                  />
                  <Route
                    path="/kanbanANR/:projectId"
                    element={<KanbanANRPage />}
                  />
                  <Route path="/Lexware" element={<Lexware />} />

                  <Route path="/ExcelBulkPage" element={<ExcelBulkPage />} />

                  {/* <Route
                    path="/ReklamationDetailView"
                    element={<ReklamationDetailView />}
                  /> */}

                  {/* <Route
                    path="/ReklamationOverview"
                    element={<ReklamationOverview />}
                  /> */}

                  <Route path="/users" element={<UserTable />} />
                  <Route path="/profile" element={<UserProfile />} />
                  <Route
                    path="/reklamation/*"
                    element={<ReklamationSystem />}
                  />
                  <Route
                    path="/invoice-dashboard"
                    element={<InvoiceDashboard />}
                  />
                  <Route
                    path="/profit-loss-invoices"
                    element={<ProfitLossInvoices />}
                  />
                  <Route path="/ai-assistant" element={<AIAssistantPage />} />
                  <Route
                    path="/ProcessImprovementPage"
                    element={<ProcessImprovementPage />}
                  />

                  {/* Stock Management Routes */}
                  <Route path="/stock" element={<StockManagement />} />
                  <Route path="/stock-old" element={<StockDashboard />} />
                  <Route path="/stock/products" element={<ProductsList />} />
                  <Route path="/stock/products/new" element={<ProductForm />} />
                  <Route
                    path="/stock/products/edit/:id"
                    element={<ProductForm />}
                  />
                  <Route path="/stock/products/:id" element={<ProductView />} />
                  <Route
                    path="/stock/products/logs"
                    element={<ProductLogs />}
                  />

                  <Route
                    path="/stock/movements"
                    element={<StockMovementsList />}
                  />
                  <Route
                    path="/stock/movements/new"
                    element={<StockMovementForm />}
                  />
                  <Route
                    path="/stock/movements/edit/:id"
                    element={<StockMovementForm />}
                  />
                  <Route path="/stock/anr/:anrId" element={<AnrStockList />} />
                  <Route path="/stock/odoo-config" element={<OdooConfig />} />
                  <Route
                    path="/stock/addAuftrage"
                    element={<StockAuftrage />}
                  />
                  <Route path="/stock/stockAnr" element={<StockAnr />} />

                  <Route
                    path="/stock/Auftrage"
                    element={<StockAuftrageView />}
                  />

                  {/*custom form*/}
                  <Route path="/custom-form/*" element={<FormManagement />} />
                  <Route path="/team2" element={<Team2 />} />

                  {/* Warehouse Management Routes */}
                  <Route path="/warehouse" element={<WarehouseList />} />
                  <Route
                    path="/warehouse/:id/designer"
                    element={<WarehouseDesigner />}
                  />

                  {/* Simple App Admin (Einfache App Verwaltung) */}
                  <Route
                    path="/simple-app-admin"
                    element={<SimpleAppAdmin />}
                  />

                  <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
              </Routes>
            </DndProvider>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
//
export default App;
